import { css } from 'styled-components'

export default css`
  &.InsightsPieChart {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .recharts-legend-wrapper {
      padding-top: 16px;
    }

    .recharts-legend-item {
      margin-right: 16px !important;
    }

    .recharts-pie-label-text {
      font-size: 12px;
      font-weight: 600;
      fill: #374151;
    }
  }
`
